import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByLetter'
})
export class FilterByLetterPipe implements PipeTransform {
  transform(items: any, letter: string): any[] {
    if (!items || !letter) {
      return items;
    }
    if (letter === 'ALL') {
      return items;
    }
    if (letter !== 'Nº') {
      return items.filter(name => name.toUpperCase().startsWith(letter));
    } else {
      return items.filter((name) => name.match(/^\d/));
    }
  }
}